import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import LanguageSetter from "./LanguageSetter";
import PortFolio from "./PortFolio";

import "react-toastify/dist/ReactToastify.css";
import ScrollToAnchor from "./ScrollToAnchor";

export default function App() {
    return (
        <Router>
            <LanguageSetter />
            <ScrollToAnchor />
            <ToastContainer position="top-left" theme="dark" />
            <Routes>
                <Route path="/" element={<PortFolio />} />
            </Routes>
        </Router>
    );
}
